import { Head } from '@inertiajs/react'

import CallToAction from '@/components/call-to-action'
import { Container } from '@/components/container'
import FaqSection from '@/components/faq-section'
import FeatureSection from '@/components/feature-section'
import { Footer } from '@/components/footer'
import { Hero } from '@/components/hero'
import { Image } from '@/components/image'
import { Navbar } from '@/components/navbar'
import PainPointSection from '@/components/pain-point-section'
import PricingSection from '@/components/pricing-section'
import TestimonialSection from '@/components/testimonials-section'
import { MotionDiv, MotionP } from '@/lib/framer'

export default function HomeIndex() {
  return (
    <>
      <Head title="Team GitHub & Slack Digests That Replace Daily Standups">
        <meta
          head-key="description"
          name="description"
          content="Team GitHub and Slack commit digests that replace daily standups. Git Digest is an async standup for engineering teams, not a repo-to-LLM ingest tool."
        />
      </Head>
      <main id="main-content" className="overflow-hidden">
        <Container>
          <Navbar />
        </Container>
        <Hero />
        <MotionDiv
          className="mx-auto my-12 max-w-[90%] px-4 text-center sm:my-16 sm:max-w-xl md:my-20 md:max-w-2xl lg:my-24"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.5 }}
        >
          <MotionP
            className="text-muted-foreground"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9, duration: 0.5 }}
          >
            Trusted by teams at leading companies to boost productivity and ship faster
          </MotionP>
          <MotionDiv initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1, duration: 0.5 }}>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
              <a
                href="https://gumroad.com?ref=gitdigest.ai"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 transition-opacity hover:opacity-80"
              >
                <div className="flex h-10 items-center justify-center">
                  <Image
                    src="/images/static/gumroad-logo.svg"
                    alt="Gumroad"
                    height={35}
                    width={220}
                    className="object-contain dark:invert"
                  />
                </div>
              </a>
              <div className="bg-border h-6 w-px" />
              <a
                href="https://klu.so?ref=gitdigest.ai"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-3 transition-opacity hover:opacity-80"
              >
                <div className="flex h-10 items-center justify-center">
                  <Image src="/images/static/klu-logo.png" alt="Klu" height={32} width={32} className="object-contain" />
                </div>
                <span className="text-foreground text-3xl font-bold">Klu</span>
              </a>
              <div className="bg-border h-6 w-px" />
              <a
                href="http://www.gemnote.com/?ref=gitdigest.ai"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-3 transition-opacity hover:opacity-80"
              >
                <div className="flex h-10 items-center justify-center">
                  <Image
                    src="/images/static/gemnote-logo.png"
                    alt="Gemnote"
                    height={28}
                    width={28}
                    className="object-contain dark:hidden"
                  />
                  <Image
                    src="/images/static/gemnote-logo-white.png"
                    alt="Gemnote"
                    height={28}
                    width={28}
                    className="hidden object-contain dark:block"
                  />
                </div>
                <span className="text-foreground text-3xl font-bold">Gemnote</span>
              </a>
            </div>
          </MotionDiv>
        </MotionDiv>
        <section aria-label="Testimonials">
          <TestimonialSection />
        </section>
        <section aria-label="Pain Points">
          <PainPointSection />
        </section>
        <section id="features" aria-labelledby="features-heading">
          <h2 id="features-heading" className="sr-only">
            Features
          </h2>
          <FeatureSection />
        </section>
        <section id="pricing" aria-labelledby="pricing-heading">
          <h2 id="pricing-heading" className="sr-only">
            Pricing
          </h2>
          <PricingSection />
        </section>
        <section id="faq" aria-labelledby="faq-heading">
          <h2 id="faq-heading" className="sr-only">
            Frequently Asked Questions
          </h2>
          <FaqSection />
        </section>
        <CallToAction />
      </main>
      <Footer />
    </>
  )
}
